<template>
  <div
    class="autographContainer"
    ref="autographContainer"
    :visible="visible"
    style="width: 100%; height: 100%; display: flex"
  >
    <canvas
      class="mycanvas"
      ref="mycanvas"
      disable-scroll="true"
      @mousedown="mousedown"
      @mousemove="mousemove"
      @mouseup="mouseup"
      @mouseleave="mouseleave"
      @touchstart="touchstart"
      @touchmove="touchmove"
      @touchend="touchend"
    ></canvas>
    <a
      v-if="showClear"
      type="primary"
      icon="delete"
      @click="clear"
      style="position: absolute; right: 10px; top: 10px; left: unset"
      >清除</a
    >
  </div>
</template>

<script>
var x = 10
var y = 10
export default {
  data() {
    return {
      visible: false,
      ctx: '', //绘图图像
      points: [], //路径点集合
      buttontype: true,
      signtype: '',
      isDraw: false,
      isPrint: false, //PC端是否触发鼠标点击
      title: '签名',
      vertex: [], //canvas画布相对于窗口的实例
      showClear: false,
    }
  },
  methods: {
    init(option) {
      this.visible = true
      this.$nextTick(() => {
        var canvas = this.$refs.mycanvas
        canvas.width = canvas.parentNode.offsetWidth
        canvas.height = canvas.parentNode.offsetHeight
        this.ctx = canvas.getContext('2d') //创建绘图对象
        //设置画笔样式
        this.ctx.fillStyle = '#ececec'
        this.ctx.fillRect(0, 0, canvas.parentNode.offsetWidth, canvas.parentNode.offsetHeight)
        // this.ctx.beginPath();
        this.ctx.strokeStyle = '#000'
        this.ctx.lineWidth = 4
        this.ctx.lineCap = 'round'
        this.ctx.lineJoin = 'round'

        if (option && option.signtype) {
          this.signtype = option.signtype
        }
      })
    },
    /* ***********************************************
			#   PC端鼠标方法
			************************************************ */

    //鼠标点击开始，获取到起点
    mousedown(e) {
      e.preventDefault()
      let startX = e.offsetX
      let startY = e.offsetY
      let startPoint = {
        X: startX,
        Y: startY,
      }
      this.points.push(startPoint)
      //每次触摸开始，开启新的路径
      this.ctx.beginPath()
      this.isPrint = true
    },

    //鼠标点击后移动，获取到路径点
    mousemove(e) {
      e.preventDefault()

      //判断是否鼠标点击并在画布内
      if (!this.isPrint) return
      let moveX = e.offsetX
      let moveY = e.offsetY
      let movePoint = {
        X: moveX,
        Y: moveY,
      }
      this.points.push(movePoint) //存点
      let len = this.points.length
      if (len >= 2) {
        this.draw() //绘制路径
      }
    },

    // 鼠标弹起结束，将未绘制的点清空防止对后续路径产生干扰
    mouseup(e) {
      e.preventDefault()
      if (this.isDraw == true) {
        var images = this.$refs.mycanvas.toDataURL('image/png')
        this.$emit('signText', images)
      }
      this.points = []
      this.isPrint = false
    },

    // 鼠标从画布失焦，将未绘制的点清空防止对后续路径产生干扰
    mouseleave(e) {
      e.preventDefault()
      if (this.isDraw == true) {
        var images = this.$refs.mycanvas.toDataURL('image/png')
        this.$emit('signText', images)
      }
      this.points = []
      this.isPrint = false
    },

    /* ***********************************************
			#   移动端触摸方法
			************************************************ */

    //触摸开始，获取到起点
    touchstart: function (e) {
      //禁用触屏滑动
      e.preventDefault()
      e.stopPropagation()

      //获取canvas画布相对于窗口的位置坐标
      this.vertex = this.$refs.mycanvas.getBoundingClientRect()
      //获取触屏坐标
      const coords = e.changedTouches ? e.changedTouches[0] : e
      let startX = coords.clientX - this.vertex.left
      let startY = coords.clientY - this.vertex.top
      let startPoint = {
        X: startX,
        Y: startY,
      }
      this.points.push(startPoint)
      //每次触摸开始，开启新的路径
      this.ctx.beginPath()
    },

    //触摸移动，获取到路径点
    touchmove: function (e) {
      //禁用触屏滑动
      e.preventDefault()
      e.stopPropagation()
      //获取canvas画布相对于窗口的位置坐标
      this.vertex = this.$refs.mycanvas.getBoundingClientRect()
      //获取触屏坐标
      const coords = e.changedTouches ? e.changedTouches[0] : e
      let moveX = coords.clientX - this.vertex.left
      let moveY = coords.clientY - this.vertex.top
      let movePoint = {
        X: moveX,
        Y: moveY,
      }
      this.points.push(movePoint) //存点
      let len = this.points.length
      if (len >= 2) {
        this.draw() //绘制路径
      }
    },

    // 触摸结束，将未绘制的点清空防止对后续路径产生干扰
    touchend: function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.isDraw == true) {
        var images = this.$refs.mycanvas.toDataURL('image/png')
        this.$emit('signText', images)
      }
      this.points = []
    },

    /* ***********************************************
			#   绘制笔迹
			#	1.为保证笔迹实时显示，必须在移动的同时绘制笔迹
			#	2.为保证笔迹连续，每次从路径集合中区两个点作为起点（moveTo）和终点(lineTo)
			#	3.将上一次的终点作为下一次绘制的起点（即清除第一个点）
			************************************************ */
    draw() {
      let point1 = this.points[0]
      let point2 = this.points[1]
      this.points.shift()
      this.ctx.moveTo(point1.X, point1.Y)
      this.ctx.lineTo(point2.X, point2.Y)
      this.ctx.stroke()
      // 标记为绘制
      this.isDraw = true
      this.showClear = true
    },

    //清空画布
    clear() {
      this.showClear = false
      let that = this

      let canvasw = that.$refs.mycanvas.width
      let canvash = that.$refs.mycanvas.height
      that.ctx.clearRect(0, 0, canvasw, canvash)
      //设置画笔样式
      that.ctx.fillStyle = '#ececec'
      that.ctx.fillRect(0, 0, canvasw, canvash)
      that.ctx.beginPath()
      that.ctx.strokeStyle = '#000'
      that.ctx.lineWidth = 4
      that.ctx.lineCap = 'round'
      that.ctx.lineJoin = 'round'
      that.$emit('clearSign')

      // 标记为未绘制
      that.isDraw = false
    },

    //完成绘画
    finish() {
      let that = this
      if (!that.buttontype) {
        return
      }
      if (!that.isDraw) {
        this.$message.warning('未获取到签名信息，请重试')
        return
      }
      that.buttontype = false
      var images = that.$refs.mycanvas.toDataURL('image/png')

      that.$emit('signText', images)
      that.buttontype = true
      that.visible = false
    },
  },
}
</script>

<style>
.mycanvas {
  background-color: #ececec;
}
</style>
